<template>
  <div class="main-view" v-loading.body="loading">
    <el-card class="searchCard" shadow="never">
      <!-- 筛选 -->
      <el-col>
        <el-form inline class="inline-form">
          <el-form-item label="返佣时间">
            <date-range-picker v-model="creatTime" :value="creatTime" ref="creatTime" @getChange="dateChange"></date-range-picker>
          </el-form-item>
          <el-form-item label="商户编号">
            <el-select
              class="search-input"
              v-model="searchInfo.merchantNo"
              placeholder="模糊搜索"
              clearable
              filterable
              remote
              :remote-method="handleMerchantInfoRemote"
              :loading="selectLoading">
              <el-option
                v-for="item in subMerchantNamesList"
                :key="item.fmerchantId"
                :label="item.fmerchantId"
                :value="item.fmerchantId">
                <span class="value">{{ item.fmerchantId }}</span>
                <span class="name">{{ item.fmerchantName }}</span>
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="下级代理商" >
            <el-select
              class="search-input"
              v-model="searchInfo.agentId"
              placeholder="模糊搜索"
              clearable
              filterable
              :filter-method="handleAgentInfoFilter">
              <el-option
                style="width:200px;"
                v-for="item in subAgentInfoList"
                :key="item.fAgentId"
                :label="item.fAgentId"
                :value="item.fAgentId">
                <span class="value">{{ item.fAgentId }}</span>
                <span class="name">{{ item.fTitle }}</span>
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <auth-button opt="search" :plain="true" icon="el-icon-search" @click.native="searchClick" label="查询" :loading="searchButtonLoading"></auth-button>
          </el-form-item>
        </el-form>
      </el-col>
      <!-- 汇总 -->
      <el-col>
        <div class="sum-view" v-if="!isInstitution">
          <div>
            <div class="sum-item-title">返佣总金额: <span>{{ totalInfo.totalAmountStr }}</span></div>
          </div>
        </div>
      </el-col>
    </el-card>
    <el-card class="tableCard" shadow="never">
      <!-- table -->
      <el-table
        stripe
        style="width:100%;"
        v-loading="tableLoading"
        :data="profitDetailList"
        :header-cell-style="{background:'#FAFAFA'}">
        <el-table-column
          prop="rebateDate"
          label="返佣时间"
          align="center"
          min-width="200">
        </el-table-column>
        <el-table-column
          prop="merchantId"
          label="商户编号"
          align="center"
          min-width="200">
        </el-table-column>
        <el-table-column
          prop="agentId"
          label="直属代理商编号"
          align="center"
          min-width="200">
        </el-table-column>
        <el-table-column
          prop="rebateAmount"
          label="返佣金额"
          align="center"
          min-width="200">
        </el-table-column>
      </el-table>
    </el-card>
    <pagination @changePage="onChangeCurrentPage" :count="paginations.count" :page-no="paginations.pageNo"></pagination>
  </div>
</template>

<script>
import qs from 'qs'
import { parseTime } from '@/utils/formatTime'
import dateRangePicker from '@/components/dateRangePicker'
import pagination from '@/components/pagination'
import { rebateDetailList } from '@/api/settle'
import { listAgentMerchant, directSubAgentInfo } from '@/api/transaction'

export default {
  name: 'ProfitDetail',
  components: {
    dateRangePicker,
    pagination
  },
  data () {
    const todayStr = (parseTime(new Date(), '{y}-{m}-{d} {h}:{i}:{s}')).substr(0, 10) + ' 23:59:59'
    const toadyZero = new Date(new Date().getTime() - 3600 * 1000 * 7 * 30)
    const todayZeroStr = parseTime(toadyZero, '{y}-{m}-{d} {h}:{i}:{s}').substr(0, 10) + ' 00:00:00'
    return {
      loading: false,
      selectLoading: false,
      // 需要给分页组件传的信息
      paginations: {
        pageNum: 1,
        count: 0,
        pageSize: 20
      },
      // 搜索表单信息
      searchInfo: {
        startDate: '',
        endDate: '',
        agentId: '',
        merchantId: ''
      },
      creatTime: [todayZeroStr, todayStr],
      profitDetailList: [],
      totalInfo: {
        totalAmountStr: ''
      },
      subAgentInfoList: [],
      subAgentInfoList_back: [],
      subMerchantNamesList: [],
      searchButtonLoading: false
    }
  },
  methods: {
    searchClick () {
      this.paginations.pageNum = 1
      this.rebateDetailList()
    },
    /**
     * 商户信息自定义筛选方法
     */
    async handleMerchantInfoRemote (queryString) {
      if (queryString) {
        this.selectLoading = true
        await this.getListAgentMerchant(queryString)
        this.selectLoading = false
      } else {
        this.subMerchantNamesList = []
      }
    },
    getListAgentMerchant (merchantId) {
      const params = qs.stringify({
        merchantName: merchantId,
        pageNo: 1,
        pageSize: 50
      })
      console.log(params)
      return new Promise((resolve, reject) => {
        listAgentMerchant(params).then(response => {
          console.log('listAgentMerchant response:', response)
          if (parseInt(response.result_cde) === 0) {
            this.subMerchantNamesList = response.list
            console.log(this.subMerchantNamesList)
            resolve()
          } else {
            this.loading = false
            this.$message({
              message: response.result_msg,
              type: 'error'
            })
          }
        }).catch(() => {
          this.loading = false
        })
      })
    },
    /**
     * 直属代理商自定义筛选方法
     */
    handleAgentInfoFilter (queryString) {
      if (queryString) {
        this.subAgentInfoList = this.subAgentInfoList_back.filter(item => {
          return item.fAgentId.toLowerCase().includes(queryString.toLowerCase()) || item.fTitle.toLowerCase().includes(queryString.toLowerCase())
        })
      } else {
        this.subAgentInfoList = this.subAgentInfoList_back
      }
    },
    getSubAgentInfo () {
      return new Promise((resolve, reject) => {
        // 设一个超大的pageSize取所有数据
        directSubAgentInfo('pageSize=655350').then(response => {
          console.log('getDirectSubAgentInfo response:', response)
          if (response.error_code === '0') {
            // const userInfo = JSON.parse(localStorage.getItem('ZZGAgentUser')).userEntity
            // const agentList = [{
            //   fAgentId: userInfo.fAgentId,
            //   fTitle: userInfo.fTitle
            // }]
            // this.subAgentInfoList = agentList.concat(response.list)
            this.subAgentInfoList = response.list
            this.subAgentInfoList_back = [...this.subAgentInfoList]
            resolve()
          } else {
            this.loading = false
            this.$message({
              message: response.error_msg,
              type: 'error'
            })
          }
        }).catch(() => {
          this.loading = false
        })
      })
    },
    dateChange (value) {
      this.creatTime = value
    },
    rebateDetailList () {
      this.searchInfo.startDate = this.creatTime && this.creatTime[0] ? this.creatTime[0] : ''
      this.searchInfo.endDate = this.creatTime && this.creatTime[1] ? this.creatTime[1] : ''
      // this.searchInfo.endDate = this.creatTime && this.creatTime[1] ? (parseTime(this.creatTime[1], '{y}-{m}-{d} {h}:{i}:{s}')).substr(0, 10) + ' 23:59:59' : ''
      const param = qs.stringify({ ...this.searchInfo, ...this.paginations })
      rebateDetailList(param).then(res => {
        console.log(res)
        if (+res.code === 0) {
          this.profitDetailList = res.data.list
          this.profitDetailList.forEach(item => {
            item.rebateAmount = (item.rebateAmount / 100).toFixed(2)
          })
          this.totalInfo.totalAmountStr = (res.data.totalAmount / 100).toFixed(2)
          this.paginations.count = res.data.totalCount
        }
      })
    }
  },
  mounted () {
    this.getSubAgentInfo()
    this.rebateDetailList()
  }
}
</script>

<style scoped>
.main-view {
  padding-left: 16px;
}
.search-input {
  width: 160px;
}
.btm-action {
  margin: 20px 0;
  text-align: center;
}
.sum-view {
  margin: 10px;
  font-size: 14px;
  display: flex;
}
.sum-item-title {
  font-weight: 700;
  margin-bottom: 30px;
}
.tip-view {
  margin: 10px;
  font-size: 14px;
}
</style>
